export default {
  header: ({ props, state }) => ({
    class: [
      'mt-4 p-8',
      // Flex
      'flex items-center justify-between',

      // Colors
      'text-primary dark:text-surface-0/80',
      'bg-white dark:bg-surface-900',

      'font-bold text-2xl',

      //Shape
      {
        'rounded-b-lg': state.d_collapsed
      },
      'rounded-t-lg'
    ]
  }),
  title: {
    class: 'text-primary'
  },
  toggler: {
    class: [
      // Alignments
      'inline-flex items-center justify-center',
      'relative',

      // Sized
      'm-0 p-0',

      //Shape
      'border-0 rounded-full',

      //Color
      'bg-white',
      'text-surface-600 dark:text-surface-0/80',

      // States
      'hover:text-surface-800 dark:hover:text-surface-0/80',
      'focus:outline-none focus:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 focus-visible:ring-inset dark:focus-visible:ring-primary-300/50',

      // Transitions
      'transition-all duration-200 ease-in-out',

      // Misc
      'overflow-hidden no-underline',
      'cursor-pointer'
    ]
  },
  togglerIcon: {
    class: 'inline-block text-xl'
  },
  content: {
    class: [
      // Spacing
      'px-8 pb-8 pt-0',

      // Shape
      'rounded-b-lg',

      //Color
      'bg-white dark:bg-surface-900',
      'text-neutral-500 dark:text-surface-0/80'
    ]
  },
  footer: {
    class: [
      // Spacing
      'py-3 p-5'
    ]
  },
  transition: {
    enterFromClass: 'max-h-0',
    enterActiveClass:
      'overflow-hidden transition-[max-height] duration-1000 ease-in-out',
    enterToClass: 'max-h-[1000px]',
    leaveFromClass: 'max-h-[1000px]',
    leaveActiveClass:
      'overflow-hidden transition-[max-height] duration-[450ms] ease-in-out',
    leaveToClass: 'max-h-0'
  }
}
